export enum SelfServeStepsIdentifiers {
  VenueDetails = 'venue-details',
  BusinessDetails = 'business-details',
  OpeningHours = 'opening-hours',
  ProductList = 'product-list',
  ServicePricing = 'service-pricing',
  DeviceSelection = 'device-selection',
  Review = 'review-info',
  MenuPhotoShoot = 'menu-photo-shoot',
}
